import { render, staticRenderFns } from "./ChipCounter.vue?vue&type=template&id=c69b3064&scoped=true&"
import script from "./ChipCounter.ts?vue&type=script&lang=ts&"
export * from "./ChipCounter.ts?vue&type=script&lang=ts&"
import style0 from "./ChipCounter.scss?vue&type=style&index=0&id=c69b3064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69b3064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
